package navigation.settings.categories.addeditcategory

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.category.domain.usecase.AddEditCategoryUseCase
import com.essntl.features.category.ui.addeditcategory.AddEditCategoryEvent
import com.essntl.features.category.ui.addeditcategory.AddEditCategoryState
import com.essntl.features.category.ui.addeditcategory.AddEditCategoryValidation
import com.essntl.features.category.ui.addeditcategory.AddEditCategoryViewModel
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.toastmanager.ToastManager

class AddEditCategoryScreenModel(
    categoryRepository: CategoryRepository,
    addEditCategoryUseCase: AddEditCategoryUseCase,
    serviceRepository: ServiceRepository,
    supplierRepository: SupplierRepository,
    fileRepository: FileRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditCategoryState>(AddEditCategoryState()) {
    val validation = AddEditCategoryValidation()

    private val viewModel =
        AddEditCategoryViewModel(
            categoryRepository = categoryRepository,
            addEditCategoryUseCase = addEditCategoryUseCase,
            serviceRepository = serviceRepository,
            supplierRepository = supplierRepository,
            fileRepository = fileRepository,
            loadingManager = loadingManager,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
        )

    fun onEvent(event: AddEditCategoryEvent) = viewModel.onEvent(event)
}